import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { ExToolbar, ExTable } from './components'

import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  actionListWithdrawal,
  actionAcceptWithdrawal,
  actionRejectWithdrawal
} from '../../store/actions/withdrawal'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}))

const WithdrawalList = ({
  withdrawal,
  acceptWithdrawal,
  rejectWithdrawal,
  dispatchListWithdrawal,
  dispatchAcceptWithdrawal,
  dispatchRejectWithdrawal
}) => {
  const classes = useStyles()
  const [onState, setOnState] = useState(true)
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [withdrawals, setWithdrawals] = useState([])

  useEffect(() => {
    if (onState) {
      dispatchListWithdrawal(page, limit)
    }
  }, [dispatchListWithdrawal, onState, page, limit])

  useEffect(() => {
    if (withdrawal.payload) {
      setWithdrawals(withdrawal.payload)
      setPage(withdrawal.page)
      setPages(withdrawal.pages)
      setOnState(false)
    }
  }, [withdrawal.payload, withdrawal.page, withdrawal.pages])

  // Refresh list after accept/reject
  useEffect(() => {
    if (acceptWithdrawal.success) {
      setOnState(true)
    }
  }, [acceptWithdrawal.success])

  useEffect(() => {
    if (rejectWithdrawal.success) {
      setOnState(true)
    }
  }, [rejectWithdrawal.success])

  const handlePageChange = (event, page) => {
    setPage(page + 1)
    setOnState(true)
  }

  const handleRowsPerPageChange = event => {
    setPage(1)
    setLimit(event.target.value)
    setOnState(true)
  }

  const handleAccept = (id) => {
    dispatchAcceptWithdrawal(id)
  }

  const handleReject = (id) => {
    dispatchRejectWithdrawal(id)
  }

  return (
    <div className={classes.root}>
      <ExToolbar />
      <div className={classes.content}>
        <ExTable
          withdrawals={withdrawals}
          page={page}
          pages={pages}
          limit={limit}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          onAccept={handleAccept}
          onReject={handleReject}
        />
      </div>
    </div>
  )
}

WithdrawalList.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    withdrawal: {
      loading: state.withdrawal.listWithdrawal.loading,
      page: state.withdrawal.listWithdrawal.page,
      pages: state.withdrawal.listWithdrawal.pages,
      payload: state.withdrawal.listWithdrawal.payload
    },
    acceptWithdrawal: {
      success: state.withdrawal.acceptWithdrawal.success
    },
    rejectWithdrawal: {
      success: state.withdrawal.rejectWithdrawal.success
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchListWithdrawal: (page, limit) => dispatch(actionListWithdrawal(page, limit)),
    dispatchAcceptWithdrawal: (id) => dispatch(actionAcceptWithdrawal(id)),
    dispatchRejectWithdrawal: (id) => dispatch(actionRejectWithdrawal(id))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(WithdrawalList)
